import { render, staticRenderFns } from "./UsuariosComunicante.vue?vue&type=template&id=4d257c8a&scoped=true&"
import script from "./UsuariosComunicante.vue?vue&type=script&lang=js&"
export * from "./UsuariosComunicante.vue?vue&type=script&lang=js&"
import style0 from "./UsuariosComunicante.vue?vue&type=style&index=0&lang=css&"
import style1 from "./UsuariosComunicante.vue?vue&type=style&index=1&id=4d257c8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d257c8a",
  null
  
)

export default component.exports